export const SUPPORT_EMAIL = 'support@fileplease.com';
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;
